<template>
  <form class="nominee-form" @submit.prevent="saveNominee">
    <button type="button" class="close" aria-label="Close" @click.stop="$emit('closeForm')"><span aria-hidden="true">&times;</span></button>
    <div class="form-group">
      <label>Nominee Name(s)</label>
      <input type="text" class="form-control" required v-model="nomineeName" />
    </div>
    <div class="form-group">
      <label>Nominee's Movie Title</label>
      <input type="text" class="form-control" required v-model="nomineeMovie" />
    </div>
    <button class=btn-primary>Save Nominee</button>
  </form>
</template>

<script>
export default {
  name: 'NomineeForm',
  data() {
    return {
      nomineeName: '',
      nomineeMovie: ''
    };
  },
  methods: {
    saveNominee() {
      this.$emit('saveNominee', { nomineeName: this.nomineeName, nomineeMovie: this.nomineeMovie });
      this.nomineeName = '';
      this.nomineeMovie = '';
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../../sass/_config';
  .nominee-form {
    border: 1px solid $border;
    border-radius: 8px;
    margin-top: 25px;
    padding: 2rem;
    position: relative;
    .close {
      position: absolute;
      right: 15px;
      top: 10px;
    }
  }
</style>
